var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialWellBeingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.61C14.2091 15.61 15.9999 13.8191 15.9999 11.61C15.9999 9.40089 14.2091 7.61005 12 7.61005C9.79085 7.61005 8 9.40089 8 11.61C8 13.8191 9.79085 15.61 12 15.61Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.06863V9.65923",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.1514V13.5518",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0245 12.5854C11.0245 13.1223 11.463 13.5607 11.9999 13.5607C12.5368 13.5607 12.9753 13.1223 12.9753 12.5854C12.9753 12.0485 12.5368 11.61 11.9999 11.61C11.463 11.61 11.0245 11.1715 11.0245 10.6346C11.0245 10.0977 11.463 9.65921 11.9999 9.65921C12.5368 9.65921 12.9753 10.0977 12.9753 10.6346",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06 5.16C22.02 7.12 22.02 10.29 20.06 12.24L11.99 20.31L3.93997 12.25C1.97997 10.29 1.97997 7.12 3.93997 5.17C5.89997 3.21 9.06997 3.21 11.02 5.17L11.99 6.14L12.97 5.16C14.93 3.2 18.1 3.2 20.05 5.16H20.06Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialWellBeingIcon);
export default __webpack_public_path__ + "static/media/financial_well_being_icon.d86e095907d010a13cd86a8257cab783.svg";
export { ForwardRef as ReactComponent };